import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";

// This is a completeness hint, not a replacement for server validation or
// stored-image verification. Numeric zero is a valid supplied answer.
export function submissionCompleteness(questions, answers, evidence = {}) {
  const requiredAnswers = questions.filter((q) => q.required);
  const requiredPhotos = questions.filter((q) => q.photo_required);
  const missingAnswers = requiredAnswers.filter((q) => {
    const value = answers[q.id];
    return value == null || (typeof value === "string" && !value.trim());
  });
  const missingPhotos = requiredPhotos.filter((q) => !evidence[q.id]);
  return {
    requiredAnswers: requiredAnswers.length,
    requiredPhotos: requiredPhotos.length,
    missingAnswers,
    missingPhotos,
    complete: !missingAnswers.length && !missingPhotos.length,
  };
}

export default function SubmissionChecklist({ completeness, dirty, photoPending }) {
  const ready = completeness.complete && !dirty && !photoPending;
  return (
    <Box component="section" aria-label="Submission checklist" sx={{ mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Before you submit
      </Typography>
      <Stack spacing={1} sx={{ mt: 1 }}>
        <Typography variant="body2">
          Required answers: {completeness.requiredAnswers - completeness.missingAnswers.length}
          /{completeness.requiredAnswers} supplied · Required photos: {completeness.requiredPhotos - completeness.missingPhotos.length}
          /{completeness.requiredPhotos} confirmed
        </Typography>
        {(completeness.missingAnswers.length > 0 || completeness.missingPhotos.length > 0) && (
          <Box component="ul" sx={{ my: 0, pl: 3 }}>
            {completeness.missingAnswers.map((q) => (
              <li key={`answer-${q.id}`}>Add an answer: {q.label}</li>
            ))}
            {completeness.missingPhotos.map((q) => (
              <li key={`photo-${q.id}`}>Add a photo: {q.label}</li>
            ))}
          </Box>
        )}
        {dirty && <Alert severity="info">Save your draft before submitting.</Alert>}
        {photoPending && (
          <Alert severity="warning">
            A selected photo is not confirmed. Finish the upload, retry it, or
            discard the local selection before submitting.
          </Alert>
        )}
        {ready && (
          <Alert severity="info">
            Required items are present. Submit to send your report for review;
            the server will validate your answers and stored photos.
          </Alert>
        )}
      </Stack>
    </Box>
  );
}
